<template>
    <select
        :id="id"
        :name="name"
        class="select"
        :class="inputClass"
        :required="required"
        :disabled="disabled"
        @change="$emit('change', $event.target.value)"
        :value="value"
    >
        <option
            :value="option.code || option"
            v-for="(option, i) in options"
            :key="i"
        >{{option.label || option}}</option>
    </select>
</template>

<script>
export default {
    name: "Select",
    props: {
        name: String,
        options: [],
        inputClass: {
            type: String,
            default: "",
        },
        value: [Number, String],
        required: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        id: String
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.select {
    font-size: normal;
    height: 48px;
    text-align: left;
    margin-bottom: 12px;
    border-radius: 8px;
    width: 100%;
    display: block;
    padding: 10px;
    background-color: rgb(249, 250, 251);
    border: 1px solid rgb(209, 213, 219);
    color: rgb(17, 24, 39);

    &:disabled {
        border-radius: 0px;
        border: none;
        background-color: #f2f2f2;
        font-size: normal;
        text-align: left;
        margin-bottom: 12px;
        width: 100%;
        display: block;
        padding: 10px;
        color: rgb(17, 24, 39);
    }
}
</style>
